import wixLocation from 'wix-location';

var x="";
var s="";
$w.onReady(function () {
	x = wixLocation.query["club"];
	if (x==undefined) {x=""};
	s="https://www.ballagan.co.il/registration-after"+"?club="+x;
});


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button10_click_1(event) {
wixLocation.to(s);
}